import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#2196f3',
        secondary: '#607d8b',
        negative: '#ff5252',
        error: '#ff6e40',
      },
    },
  },
});
